import { useState, useEffect, useCallback } from 'react';
import { testService } from '../services/testService';

export const useTests = () => {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refreshTests = useCallback(async (options = {}) => {
    const showLoading = options.showLoading === true;
    if (showLoading) {
      setLoading(true);
    }
    try {
      const data = await testService.getTests();
      // Handle different response structures if necessary
      setTests(data.data || data.Tests || data.tests || []);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to fetch tests');
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  }, []);

  const updateTest = async (id, data) => {
    const res = await testService.updateTest(id, data);
    if (res.status === 'success') refreshTests();
    return res;
  };

  const deleteTest = async (id) => {
    const res = await testService.deleteTest(id);
    if (res.status === 'success') {
      setTests((prev) => prev.filter((t) => String(t.id) !== String(id)));
    }
    return res;
  };

  const removeTestPack = useCallback((assessmentId, packId) => {
    setTests((prev) =>
      prev.map((test) => {
        if (String(test.id) !== String(assessmentId)) return test;
        const packs = test.test_packs || test.testPacks || [];
        const nextPacks = packs.filter((p) => String(p.id) !== String(packId));
        return { ...test, test_packs: nextPacks, testPacks: nextPacks };
      })
    );
  }, []);

  useEffect(() => {
    refreshTests({ showLoading: true });
  }, [refreshTests]);

  return { tests, loading, error, refreshTests, updateTest, deleteTest, removeTestPack };
};
